import LotDiscountExpenseRepository from '@/shared/http/repositories/business/lotdiscountexpense.js'
import ExpenseAttachmentLogRepository from '@/shared/http/repositories/business/expenseattachmentlog.js'
import TermlogAttachedRepository from '@/shared/http/repositories/business/termlogattached.js'
import { toast, loading } from '@/shared/utils/UIHelper'
import JSZip from 'jszip'
import { saveAs } from 'file-saver'

export default {
  name: 'ModalHistory',
  // Task 046: empresa da tela, vinda do pai (TableTravelAdvance / TableTravelComision). O modal nao tem o
  // mixin actionsForm, entao nao tem CompanySelected proprio.
  props: {
    empresaId: { type: String, default: null }
  },
  data () {
    return {
      getAllDespesaDesconto: [],
      getAllDespesaReembolso: [],
      loteAdiantamento: null
    }
  },
  methods: {
    show () {
      this.GetAllDespesaDesconto()
      this.GetAllDespesaReembolso()
      this.loteAdiantamento = null
      this.$refs['history-lote'].show()
    },
    GetAllDespesaDesconto () {
      loading.push()
      LotDiscountExpenseRepository.GetAll()
        .then(Response => {
          this.getAllDespesaDesconto = Response.data
          loading.pop()
        })
        .catch(Error => {
          loading.pop()
        })
    },
    GetAllDespesaReembolso () {
      loading.push()
      ExpenseAttachmentLogRepository.GetAll(this.empresaId)
        .then(Response => {
          loading.pop()
          this.getAllDespesaReembolso = Response.data
        })
        .catch(Error => {
          loading.pop()
        })
    },
    // Rebaixar a planilha do lote de ADIANTAMENTO (termoanexolog). Antes nao havia caminho nenhum:
    // o download so acontecia no instante de gerar o lote, no importDes do TableTravelAdvance, que
    // monta o arquivo no cliente e cujo catch so cobre falha de request. Se aquele clique falha, o
    // lote nasce e o Excel so sai do banco — foi o lote 661 da CINTHIA em 10/09/2026.
    //
    // E BUSCA por numero, nao lista. A primeira versao listava todos os lotes num grid de fichas e
    // foi REPROVADA na revisao adversarial: `termoanexolog` tem 5 colunas e nenhuma de empresa
    // (nem autor), entao um grid navegavel transforma um artefato de write-time num acervo de 661
    // planilhas cross-empresa. Quem acabou de gerar o lote tem o numero na mao; digitar um numero
    // nao enumera nada.
    buscarLoteAdiantamento () {
      const lote = parseInt(this.loteAdiantamento, 10)
      if (!lote || lote <= 0) {
        toast.warning('Informe o numero do lote.')
        return
      }
      loading.push()
      TermlogAttachedRepository.GetByLote(lote, this.empresaId)
        .then(Response => {
          const obj = Response.data
          if (!obj) {
            toast.warning(`Nao existe o lote ${lote}.`)
            return
          }
          // 19 dos 661 lotes de producao estao com `arquivo` nulo — lote numerado sem planilha,
          // que a geracao produz quando estoura no meio (o TermoAnexoLog e salvo antes de montar
          // o xlsx). Avisar e melhor que entregar arquivo vazio.
          if (!obj.arquivo) {
            toast.error(`O lote ${lote} existe mas nao tem planilha gravada.`)
            return
          }
          const bytes = Uint8Array.from(atob(obj.arquivo), c => c.charCodeAt(0))
          const contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          const a = window.document.createElement('a')
          a.href = window.URL.createObjectURL(new Blob([bytes], { type: contentType }))
          a.download = obj.nomeArquivo || `lote-${lote}.xlsx`
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        })
        .catch(Error => {
          toast.error(`Nao foi possivel buscar o lote ${lote}.`)
        })
        .finally(() => {
          loading.pop()
        })
    },
    download (arquivo) {
      var zip = new JSZip()
      let img = zip.folder('Lote')
      img.file(`lote-${arquivo.lote}.xlsx`, arquivo.arquivo, {base64: true, createFolders: true})
      zip.generateAsync({
        type: 'blob'
      }).then(function (content) {
        saveAs(content, 'lotes.zip')
      })
    }
  }

}



// WEBPACK FOOTER //
// ./src/views/private/travelreimbursement/components/modalhistory/ModalHistory.js